import { render, staticRenderFns } from "./DocumentPortalView.vue?vue&type=template&id=2211ba6a&scoped=true&"
import script from "./DocumentPortalView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalView.vue?vue&type=style&index=0&id=2211ba6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2211ba6a",
  null
  
)

export default component.exports